import React from "react";
import clsx from "clsx";

import { Icon, IconBox } from "@proda-ai/ui-kit";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import Badge from "@/ui/atoms/Badge";
import Typography from "@/ui/atoms/Typography";

export type ABTLCollapsibleProps = BoxProps;

const BELOW_THE_LINE_GRID_HEIGHT = 200;

export const testId = "ABTLCollapsible";
const ABTLCollapsible = (props: ABTLCollapsibleProps) => {
    const { sx, children, className, ...otherProps } = props;

    const [openBelowTheLineGrid, setOpenBelowTheLineGrid] =
        React.useState(false);

    return (
        <>
            <Box
                data-testid={testId}
                className={clsx([testId, className])}
                onClick={() => setOpenBelowTheLineGrid(!openBelowTheLineGrid)}
                sx={{
                    backgroundColor: "var(--proda-white-l95)",
                    borderWidth: openBelowTheLineGrid
                        ? "1px 1px 1px 1px"
                        : "1px 1px 0px 1px",
                    transition: "border-width 0.3s ease-in-out",
                    borderStyle: "solid",
                    borderColor: "var(--proda-white-150)",
                    padding: "16px",
                    height: "48px",
                    width: "100%",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    gap: "8px",
                    ...sx,
                }}
                {...otherProps}
            >
                <IconBox
                    style={{
                        transition: "transform 0.3s ease-in-out",
                        transform: openBelowTheLineGrid
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                    }}
                >
                    <Icon icon="caret-down" color="var(--proda-black-10)" />
                </IconBox>
                <Badge severity={"inactive"} leadingIcon={null}>
                    <Box
                        component={"span"}
                        sx={{
                            textTransform: "capitalize",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Below The Line
                    </Box>
                </Badge>
                <Typography
                    variant="body3"
                    sx={{
                        color: "var(--proda-black-10)",
                        fontStyle: "italic",
                    }}
                >
                    Not included in Net Income Total
                </Typography>
            </Box>
            <Box
                sx={{
                    height: openBelowTheLineGrid
                        ? BELOW_THE_LINE_GRID_HEIGHT
                        : 0,
                    transition: "height 0.3s ease-in-out",
                    width: "100%",
                }}
            >
                {children}
            </Box>
        </>
    );
};

export default ABTLCollapsible;
